(function () {
  'use strict';
  var busy = false;
  var revision = 0;
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  var widgets = function () { return document.querySelectorAll('ayla-gift-wrap'); };

  async function cartRequest(path, body) {
    var response = await fetch(root + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    });
    if (!response.ok) throw new Error('Cart request failed');
    return response.json();
  }

  function sync(cart) {
    widgets().forEach(function (widget) {
      var checkbox = widget.querySelector('input');
      checkbox.checked = cart.items.some(function (item) { return String(item.variant_id) === widget.dataset.variantId; });
      checkbox.disabled = busy;
    });
  }

  class AylaGiftWrap extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      var checkbox = this.querySelector('input');
      var status = this.querySelector('[role="status"]');
      var initialRevision = revision;
      cartRequest('cart.js').then(function (cart) {
        if (!busy && initialRevision === revision) sync(cart);
      }).catch(() => { status.textContent = this.dataset.error; });

      checkbox.addEventListener('change', async () => {
        if (busy) return;
        var desired = checkbox.checked;
        busy = true;
        revision += 1;
        widgets().forEach(function (widget) {
          widget.setAttribute('aria-busy', 'true');
          widget.querySelector('input').disabled = true;
          widget.querySelector('[role="status"]').textContent = widget.dataset.loading;
        });
        var success = false;
        try {
          var before = await cartRequest('cart.js');
          var items = before.items.filter(item => String(item.variant_id) === this.dataset.variantId);
          if (desired && items.length === 0) {
            await cartRequest('cart/add.js', { items: [{ id: Number(this.dataset.variantId), quantity: 1 }] });
          } else if (!desired) {
            for (var item of items) await cartRequest('cart/change.js', { id: item.key, quantity: 0 });
          }
          var cart = await cartRequest('cart.js');
          busy = false;
          sync(cart);
          if (window.sharedFunctions && typeof window.sharedFunctions.updateSidebarCart === 'function') {
            window.sharedFunctions.updateSidebarCart(cart);
          } else {
            window.location.assign(root + 'cart');
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          success = true;
        } catch (error) {
          busy = false;
          try { sync(await cartRequest('cart.js')); } catch (syncError) { checkbox.checked = !desired; }
        } finally {
          busy = false;
          widgets().forEach(function (widget) {
            widget.setAttribute('aria-busy', 'false');
            widget.querySelector('input').disabled = false;
            widget.querySelector('[role="status"]').textContent = success ? (desired ? widget.dataset.added : widget.dataset.removed) : widget.dataset.error;
          });
        }
      });
    }
  }

  document.addEventListener('cart-update', function (event) {
    if (!busy && event.detail && Array.isArray(event.detail.items)) { revision += 1; sync(event.detail); }
  });
  if (!customElements.get('ayla-gift-wrap')) customElements.define('ayla-gift-wrap', AylaGiftWrap);
})();
